import type { RouteRecordRaw } from 'vue-router';

/**
 * SMS routes.
 *
 * Маршрутизация:
 *   StreamGroup (stream_id + direction_id + CDP)
 *     → RoutingChoice (group_id + aggregator_id + % + parent_id)
 *       → domains / sender_names / message_templates
 */
export const routes: RouteRecordRaw[] = [
  {
    path: '/sms',
    component: () => import('./pages/SmsHomePage.vue'),
    meta: { title: 'SMS', moduleId: 'sms' },
  },
  {
    path: '/sms/directions',
    component: () => import('./pages/DirectionsPage.vue'),
    meta: { title: 'Направления', moduleId: 'sms' },
  },
  {
    path: '/sms/aggregators',
    component: () => import('./pages/AggregatorsPage.vue'),
    meta: { title: 'Агрегаторы', moduleId: 'sms' },
  },
  {
    path: '/sms/accounts',
    component: () => import('./pages/AccountsPage.vue'),
    meta: { title: 'Учетные записи', moduleId: 'sms' },
  },
  {
    path: '/sms/smpp-clients',
    redirect: '/sms/accounts',
  },
  {
    path: '/sms/streams',
    component: () => import('./pages/StreamsPage.vue'),
    meta: { title: 'Каналы', moduleId: 'sms' },
  },
  {
    path: '/sms/routing-choices',
    component: () => import('./pages/RoutingChoicesPage.vue'),
    meta: { title: 'Маршрутизация', moduleId: 'sms' },
  },
  {
    path: '/sms/routing-choices/:streamId/new',
    component: () => import('./pages/RoutingChoiceEditPage.vue'),
    meta: { title: 'Новая группа маршрутизации', moduleId: 'sms' },
  },
  {
    path: '/sms/routing-choices/:streamId/:groupId/routing',
    component: () => import('./pages/RoutingTrafficPage.vue'),
    meta: { title: 'Распределение трафика', moduleId: 'sms' },
  },
  {
    path: '/sms/routing-choices/:streamId/:groupId',
    component: () => import('./pages/RoutingChoiceEditPage.vue'),
    meta: { title: 'Группа маршрутизации', moduleId: 'sms' },
  },
  {
    path: '/sms/streams/:streamId',
    redirect: (to) => ({
      path: '/sms/routing-choices',
      query: { streamId: String(to.params.streamId) },
    }),
  },
  {
    path: '/sms/domains',
    component: () => import('./pages/DomainsPage.vue'),
    meta: { title: 'Домены', moduleId: 'sms' },
  },
  {
    path: '/sms/sender-names',
    component: () => import('./pages/SenderNamesPage.vue'),
    meta: { title: 'Имена отправителей', moduleId: 'sms' },
  },
  {
    path: '/sms/message-templates',
    component: () => import('./pages/MessageTemplatesPage.vue'),
    meta: { title: 'Шаблоны сообщений', moduleId: 'sms' },
  },
  {
    path: '/sms/message-types',
    component: () => import('./pages/MessageTypesPage.vue'),
    meta: { title: 'Типы сообщений', moduleId: 'sms' },
  },
  {
    path: '/sms/keywords',
    component: () => import('./pages/KeywordsPage.vue'),
    meta: { title: 'Стоп-слова', moduleId: 'sms' },
  },
  {
    path: '/sms/reports',
    component: () => import('./pages/ReportsPage.vue'),
    meta: { title: 'Отчёт', moduleId: 'sms' },
  },
  {
    path: '/sms/stats',
    component: () => import('./pages/StatisticsPage.vue'),
    meta: { title: 'Статистика', moduleId: 'sms' },
  },
  {
    path: '/sms/links',
    component: () => import('./pages/LinksPage.vue'),
    meta: { title: 'Ссылки', moduleId: 'sms' },
  },
  {
    path: '/sms/send-sms',
    component: () => import('./pages/SendSmsPage.vue'),
    meta: { title: 'Отправка SMS', moduleId: 'sms' },
  },
];
